"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "20", height: "26", viewBox: "0 0 20 26", className: "Icon export-markdown", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#CACACA", d: "M0 0v26h20V6.999L13 0z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h11v7h7v17H1z" }),
            _react2.default.createElement("path", { fill: "#FFF", d: "M13 1.417l5.581 5.582H13z" }),
            _react2.default.createElement("path", { d: "M3.996 12.152h1.536l1.416 3.864.516 1.488h.048l.504-1.488 1.392-3.864h1.536V20H9.636v-3.588c0-.184.006-.384.018-.6.012-.216.026-.434.042-.654.016-.22.036-.436.06-.648.024-.212.044-.41.06-.594h-.048l-.636 1.788-1.356 3.564h-.648l-1.356-3.564-.624-1.788H5.1l.054.594.06.648c.02.22.036.438.048.654.012.216.018.416.018.6V20H3.996v-7.848zM14.5 20l2.5-3h-5l2.5 3zm-.5-8h1v5h-1v-5z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/export-markdown.js
// module id = 1801
// module chunks = 0